import React, {
    useState,
    useEffect
} from 'react';

import {
    QueryClient, QueryClientProvider
} from 'react-query';

import PropTypes from 'prop-types';

import CompanySets from './CompanySets.jsx';
import CompaniesSelector from './CompaniesSelector.jsx';
import SaveStatus from './SaveStatus.jsx';
import RIQButton from '../../../../components/RIQButton.jsx';


const queryClient = new QueryClient();

CompanySetManager.propTypes = {
    companies: PropTypes.array.isRequired,
    onCloseModal: PropTypes.func.isRequired
};

export default function CompanySetManager({companies, onCloseModal}) {

    const [selectedCompanySetName, setSelectedCompanySetName] = useState(null);

    // This effect will call onCloseModal when the user hits the Escape key.
    useEffect(() => {

        const listener = (e) => {
            if (e.key === 'Escape') {
                onCloseModal();
            }
        };
        window.addEventListener('keydown', listener);

        return () => {
            window.removeEventListener('keydown', listener);
        };
    }, [onCloseModal]);

    return (
        <QueryClientProvider client={queryClient}>
            <div className='tlw-flex tlw-flex-col'>
                <div className='tlw-border-0 tlw-border-b tlw-border-solid tlw-border-gray-300 tlw-p-7.5'>
                    <h4 className='tlw-m-0 tlw-leading-base'>Company Set Manager</h4>
                    <span>Use Company Sets to refine your analysis by segmenting companies into groups.</span>
                </div>

                <div className='tlw-flex'>
                    <CompanySets
                        className='tlw-w-5/12 tlw-flex-initial tlw-grow'
                        selectedCompanySetName={selectedCompanySetName}
                        updateSelectedCompanySetName={setSelectedCompanySetName}
                        heightClass='tlw-h-[406px]'
                    />

                    <CompaniesSelector
                        className='tlw-w-7/12 tlw-flex-initial tlw-grow'
                        companies={companies}
                        selectedCompanySetName={selectedCompanySetName}
                        heightClass='tlw-h-[406px]'
                    />
                </div>

                <div className='tlw-flex tlw-items-center tlw-border-b-0 tlw-border-l-0 tlw-border-r-0 tlw-border-t-0.5 tlw-border-solid tlw-border-gray-300 tlw-p-7.5'>
                    <div
                        className='tlw-grow'
                    >

                        Learn about&nbsp;
                        <a
                            href='https://help.rivaliq.com/en/articles/2043669-organizing-and-optimizing-your-landscape-setup'
                            target='_blank'
                            rel='noreferrer'
                        >
                            Company Sets
                        </a>, how to&nbsp;

                        <a
                            href='https://help.rivaliq.com/en/articles/457823-how-do-i-add-companies-or-change-the-focus-company-of-a-landscape'
                            target='_blank'
                            rel='noreferrer'
                        >
                            add a company
                        </a>, or how to&nbsp;

                        <a
                            href='http://help.rivaliq.com/en/articles/457823-how-do-i-add-companies-or-change-the-focus-company-of-a-landscape#h_16d968413c'
                            target='_blank'
                            rel='noreferrer'
                        >
                            change the focus company
                        </a>.
                    </div>

                    <SaveStatus/>

                    <RIQButton
                        className='tlw-px-6 tlw-py-2.5 tlw-text-md tlw-leading-[1.5]'
                        onClick={onCloseModal}>
                        Close
                    </RIQButton>
                </div>
            </div>
        </QueryClientProvider>
    );
}
